import NetworkManager from '@tencent/netcheck/lib/network-manager';
import { createSingleton } from '@tencent/netcheck/lib/helper';
import { InjectorService } from '@tencent/ioc';
import { IWorkbenchSettings } from '../../services/settings/workbench-settings.interface.js';

/**
 * @internal
 */
class NetworkManagerWrapper {
    static getInstance() {
        var _a;
        if (NetworkManagerWrapper.networkInstance === undefined) {
            const settings = InjectorService.get(IWorkbenchSettings);
            const instance = NetworkManager.create((_a = settings.network) !== null && _a !== void 0 ? _a : {});
            NetworkManagerWrapper.networkInstance = createSingleton(instance);
        }
        return NetworkManagerWrapper.networkInstance;
    }
}

export { NetworkManagerWrapper };
//# sourceMappingURL=netcheck-instance.js.map
